!function () {
    var util = angular.module('gymsystem.util');
    util.factory('Data', ['$rootScope', '$q', '$injector', '$filter', 'server', 'live', 'pubsub', 'Link', function ($rootScope, $q, $injector, $filter, server, live, pubsub, Link) {
            var Data = {};
            var isStaffApp = !!$rootScope.getMember;
            var cache = {};
            var getClass = (function () {
                var classFn = {};
                return function (type) {
                    var fn = classFn[type];
                    if (!fn)
                        classFn[type] = fn = new Function("return function ".concat(type, "(){}"));
                    return fn();
                };
            })();
            var changedItems = [];
            var publishChanges = function () {
                if (!changedItems.length)
                    return;
                var items = changedItems;
                changedItems = [];
                var types = {};
                items.forEach(function (i) {
                    var type = i.__link.type;
                    types[type] = true;
                    pubsub.publish("data.".concat(type, ".").concat(i.__link.id), i);
                });
                for (var type in types)
                    pubsub.publish('data.' + type);
            };
            var convertItem = function (raw) {
                var type = raw.__link.type;
                if (!type)
                    throw 'Data: No type found';
                if (!cache[type])
                    cache[type] = {};
                if (isStaffApp && type === 'user') {
                    var user = $rootScope.getMember(raw.id);
                    if (!user)
                        throw 'User not found';
                    // copy extra info
                    for (var k in raw) {
                        if (!(k in user))
                            user[k] = raw[k];
                    }
                    cache[type][raw.id] = user;
                    changedItems.push(user);
                    return user;
                }
                var item = cache[type][raw.id];
                if (item) {
                    _.extend(item.__proto__, raw);
                }
                else {
                    var cls = getClass(type);
                    cls.prototype = raw;
                    item = new cls();
                    cache[type][item.id] = item;
                    if (type === 'trainingcardtype') {
                        if (raw.methods) {
                            raw.methods.forEach(function (m) {
                                Data.load('paymentmethod', m);
                            });
                        }
                        raw.isProduct = function () {
                            return (!this.boundTime && !this.boundType && !this.validTime && !this.validType && (!this.priceType || this.priceType === 'OneTime') && !this.trainingsessions) || this.giftcard || this.valuecard;
                        };
                        raw.needs_to_choose_variant = function () {
                            return this.variants && this.variants.length && (this.variants.length > 1 || (this.variants[0].name != 'Standard' && this.variants[0].name));
                        };
                        raw.updateVariants = function () {
                            var site_id = $rootScope.settings && $rootScope.settings.stockPerSite ? $rootScope.selectedSite.id : 1;
                            (raw.variants || []).forEach(function (v) {
                                var s = _.findWhere(v.stock_sites, { site_id: site_id });
                                v.stock = s ? s.stock : null;
                            });
                        };
                        raw.visibleOnSite = function () {
                            return !raw.visible_sites || raw.visible_sites.length == 0 || raw.visible_sites.indexOf($rootScope.selectedSite.id) != -1;
                        };
                        raw.updateVariants();
                    }
                    else if (type === 'resourcebookingservice') {
                        raw.getPrice = function () {
                            var card = Data.get(this.trainingcard_link);
                            return card.price;
                        };
                    }
                }
                changedItems.push(item);
                return item;
            };
            var convertItemList = function (list, type) {
                list.forEach(function (i) {
                    if (i.id && type)
                        i.__link = Link(type, i.id);
                    convertItem(i);
                });
            };
            var loadMember = function () {
                return $q.promise(function (resolve, reject) {
                    if ($rootScope.member)
                        resolve($rootScope.member);
                    else {
                        $rootScope.fetchMember["finally"](function () {
                            resolve($rootScope.member);
                        }, reject);
                    }
                });
            };
            var userPromise = {};
            var oneItemPromise = {};
            function loadOne(type, id) {
                if (!id)
                    throw 'wrong id';
                if (Data.get(type, id))
                    return $q.promise(function (resolve) { resolve(Data.get(type, id)); });
                if (type === 'user' && userPromise[id])
                    return userPromise[id];
                if (oneItemPromise[type + ':' + id])
                    return oneItemPromise[type + ':' + id];
                var promise = $q.promise(function (resolve, reject) {
                    if (type === 'trainingcardtype' || type === 'paymentmethod') {
                        var load = function () {
                            if (cache[type][id])
                                return resolve(cache[type][id]);
                            server.post2('/api/public/db/search', {
                                query: { type: type, id: [id] }
                            }).then(function (response) {
                                oneItemPromise[type + ':' + id] = null;
                                response.result.forEach(convertItem);
                                resolve(Data.get(type, id));
                                publishChanges();
                            }, reject);
                        };
                        if (!loadLoaded[type])
                            Data.load(type)["finally"](load);
                        else
                            load();
                    }
                    else if (type === 'resourcebookingservice') {
                        server.post2('/api/public/db/search', {
                            query: { type: type, id: [id] }
                        }).then(function (response) {
                            response.result.forEach(convertItem);
                            resolve(Data.get(type, id));
                            publishChanges();
                        }, reject);
                    }
                    else if (type === 'user') {
                        server.get('/api/user/get', { id: id }).then(function (user) {
                            userPromise[id] = null;
                            convertItemList([user], 'user');
                            resolve(Data.get(type, id));
                            publishChanges();
                        }, reject);
                    }
                    else if (type === 'interest') {
                        Data.load(type).then(function () {
                            var result = Data.get(type, id);
                            if (result)
                                resolve(result);
                            else
                                reject();
                        }, reject);
                    }
                    else
                        throw ('Wrong type');
                });
                if (type === 'user')
                    userPromise[id] = promise;
                else if (type === 'paymentmethod') {
                    oneItemPromise[type + ':' + id] = promise;
                }
                return promise;
            }
            var loadPromise = {};
            var loadLoaded = {};
            Data.load = function (type, id) {
                if (id)
                    return loadOne(type, id);
                if (loadPromise[type])
                    return loadPromise[type];
                if (loadLoaded[type])
                    return $q.promise(function (resolve) { resolve(Data.getList(type)); });
                var promise = $q.promise(function (resolve, reject) {
                    if (type === 'trainingcardtype') {
                        loadMember().then(function (member) {
                            function processCardType(response) {
                                $q.waitBlock(function () {
                                    convertItemList(response, 'trainingcardtype');
                                })["finally"](function () {
                                    resolve(Data.getList('trainingcardtype'));
                                    loadLoaded[type] = true;
                                    loadPromise[type] = null;
                                    publishChanges();
                                }, reject);
                            }
                            if (member)
                                server.get('/api/memberapi/trainingcard/type/get').then(processCardType, reject);
                            else
                                server.get('/api/public/trainingcard/type/get', { trial: true }).then(processCardType, reject);
                        }, reject);
                    }
                    else if (type === 'paymentmethod') {
                        server.post2('/api/public/db/search', {
                            query: { type: 'paymentmethod', webshop: true }
                        }).then(function (response) {
                            response.result.forEach(convertItem);
                            resolve(Data.getList('paymentmethod'));
                            loadLoaded[type] = true;
                            loadPromise[type] = null;
                            publishChanges();
                        }, reject);
                    }
                    else if (type === 'interest') {
                        server.get('/api/memberapi/interest/get').then(function (response) {
                            convertItemList(response, 'interest');
                            resolve(Data.getList('interest'));
                            loadLoaded[type] = true;
                            loadPromise[type] = null;
                            publishChanges();
                        }, reject);
                    }
                    else
                        throw new Error('Wrong type');
                });
                loadPromise[type] = promise;
                return promise;
            };
            Data.getList = function (type) {
                if (!cache[type])
                    return [];
                return _.values(cache[type]);
            };
            Data.get = function (type, id) {
                if (!id && type instanceof Link) {
                    id = type.id;
                    type = type.type;
                }
                if (!cache[type])
                    return null;
                return cache[type][id];
            };
            Data.clearCache = function (type) {
                loadLoaded[type] = false;
            };
            Data.updateVariants = function () {
                Object.values(cache.trainingcardtype || {}).forEach(function (i) { return i.__proto__.updateVariants(); });
            };
            live.subscribe({
                type: 'trainingcardtype',
                callback: function (_, event) {
                    $q.waitBlock(function () {
                        event.data.forEach(function (cardtype) {
                            cardtype.__link = Link('trainingcardtype', cardtype.id);
                            convertItem(cardtype);
                        });
                    })["finally"](publishChanges);
                }
            });
            ['paymentmethod', 'interest', 'user'].forEach(function (type) {
                var callback = function (event) {
                    event.data.forEach(function (obj) {
                        obj.__link = Link(type, obj.id);
                        convertItem(obj);
                        if (event.action === 'remove')
                            delete cache[type][obj.id];
                    });
                    publishChanges();
                };
                live.subscribe({
                    type: type,
                    callback: function (_, event) {
                        if (type === 'user')
                            setTimeout(function () { return callback(event); }, 1);
                        else
                            callback(event);
                    }
                });
            });
            return Data;
        }]);
    /*
        {{list_of_id | data:'interest:name' | join}}
        {{id | data:'interest:name'}}
    */
    util.filter('data', ['Data', 'Link', function (Data, Link) {
            var failed = {};
            var get = function (id, type, key) {
                if (failed["".concat(type, ":").concat(id)])
                    return '-'; // removed or not available item
                var obj = Data.get(type, id);
                if (obj)
                    return obj[key];
                else
                    Data.load(type, id)["catch"](function () { return failed["".concat(type, ":").concat(id)] = true; });
                return '';
            };
            return function (id, fullKey) {
                if (!id)
                    return '';
                var type, key;
                if (id instanceof Link) {
                    type = id.type;
                    id = id.id;
                }
                ;
                if (fullKey) {
                    var d = fullKey.split(':');
                    if (d.length === 1) {
                        key = fullKey;
                    }
                    else {
                        type = d[0];
                        key = d[1];
                    }
                }
                key = key || 'name';
                if (Array.isArray(id)) {
                    return id.map(function (id) {
                        return get(id, type, key);
                    });
                }
                return get(id, type, key);
            };
        }]);
}();
